import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';
import { Injectable } from '@angular/core';

export class ResolucionFilter extends FilterData {
    dataIni: Date;
    dataFi: Date;
    constructor(sortField: string, sortDir: SortDirection) {
        super(sortField, sortDir);
        this.dataIni=null;
        this.dataFi=null;
    
        this.labels['dataIni']=this.i18n['DataIni'];
        this.labels['dataFi']=this.i18n['DataFi'];
    }
}